import styled from 'styled-components'

export const FormElement = styled.div`
  margin-bottom: var(--size-medium);
  display: flex;
  flex-direction: column;
`
